import { render, staticRenderFns } from "./RoosterLinkModal.vue?vue&type=template&id=63fc56ed&"
import script from "./RoosterLinkModal.vue?vue&type=script&lang=js&"
export * from "./RoosterLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports